<template>
    <button @click="clicked" :class="[ classes ]">
        <i v-if="icon != ''" :class="icon"></i>
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        color: { type: String, default: 'green' },
        outline: { type: Boolean, default: false },
        text: { type: Boolean, default: false },
        size: { type: String, default: '' },
        icon: { type: String, default: '' },
        iconLeft: { type: Boolean, default: false },
        iconRight: { type: Boolean, default: false },
        iconOnly: { type: Boolean, default: false },
        iconRound: { type: Boolean, default: false },
        loading: {type: Boolean, default: false},
        submit: {type: Boolean, default: false},
        disabled: {type: Boolean, default: false},
        social: {type: String, default: ''}
    },
    computed: {
        classes () {
            const { color, outline, text, size, iconRight, iconLeft, iconOnly, iconRound, loading, submit, disabled, social } = this
            
            const colorExt = outline ? '-alt' : text ? '-text' : ''
            
            return [
                ...(color ? [`button--${color}${colorExt}`] : [null]),
                ...(size ? [`button--${size}`] : [null]),
                ...(iconRight ? [`button--icon-right`] : iconLeft ? [`button--icon-left`] : iconOnly ? [`button--icon`] : iconRound ? [`button--icon-round`] : [null]),
                ...(loading ? [`js-button__loading button--loading`] : [null]),
                ...(submit ? [`button--submit`] : [null]),
                ...(disabled ? [`disabled`] : [null]),
                ...(social ? [`button--${social}`] : [null])
            ]
        },
    },
    methods: {
        clicked: function(e) {
            this.$emit('click', e);

            if(this.classes.includes('js-button__loading button--loading')){
                const elChild = document.createElement("i");
                elChild.classList.add('fas', 'fa-spinner', 'fa-pulse');
                e.target.insertBefore(elChild, e.target.firstChild);
            }
        }
    }
}
</script>